/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDeviceInfoRequest
 */
export interface UpdateDeviceInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceInfoRequest
     */
    deviceType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceInfoRequest
     */
    deviceBrand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceInfoRequest
     */
    devicePlatform?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeviceInfoRequest
     */
    deviceOsVersion?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeviceInfoRequest
     */
    deviceOsApi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceInfoRequest
     */
    webUa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeviceInfoRequest
     */
    cpuAbi?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeviceInfoRequest
     */
    resolutionWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeviceInfoRequest
     */
    resolutionHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeviceInfoRequest
     */
    dpi?: number | null;
}

/**
 * Check if a given object implements the UpdateDeviceInfoRequest interface.
 */
export function instanceOfUpdateDeviceInfoRequest(value: object): value is UpdateDeviceInfoRequest {
    return true;
}

export function UpdateDeviceInfoRequestFromJSON(json: any): UpdateDeviceInfoRequest {
    return UpdateDeviceInfoRequestFromJSONTyped(json, false);
}

export function UpdateDeviceInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeviceInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceType': json['device_type'] == null ? undefined : json['device_type'],
        'deviceBrand': json['device_brand'] == null ? undefined : json['device_brand'],
        'devicePlatform': json['device_platform'] == null ? undefined : json['device_platform'],
        'deviceOsVersion': json['device_os_version'] == null ? undefined : json['device_os_version'],
        'deviceOsApi': json['device_os_api'] == null ? undefined : json['device_os_api'],
        'webUa': json['web_ua'] == null ? undefined : json['web_ua'],
        'cpuAbi': json['cpu_abi'] == null ? undefined : json['cpu_abi'],
        'resolutionWidth': json['resolution_width'] == null ? undefined : json['resolution_width'],
        'resolutionHeight': json['resolution_height'] == null ? undefined : json['resolution_height'],
        'dpi': json['dpi'] == null ? undefined : json['dpi'],
    };
}

export function UpdateDeviceInfoRequestToJSON(json: any): UpdateDeviceInfoRequest {
    return UpdateDeviceInfoRequestToJSONTyped(json, false);
}

export function UpdateDeviceInfoRequestToJSONTyped(value?: UpdateDeviceInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_type': value['deviceType'],
        'device_brand': value['deviceBrand'],
        'device_platform': value['devicePlatform'],
        'device_os_version': value['deviceOsVersion'],
        'device_os_api': value['deviceOsApi'],
        'web_ua': value['webUa'],
        'cpu_abi': value['cpuAbi'],
        'resolution_width': value['resolutionWidth'],
        'resolution_height': value['resolutionHeight'],
        'dpi': value['dpi'],
    };
}

